/**
 * @generated SignedSource<<537e3379a5747319bc7a88f291bfe129>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Round_Round$data = {
  readonly booking: {
    readonly __typename: string;
    readonly startSlot: {
      readonly agenda: {
        readonly facility: {
          readonly copyOverrides: {
            readonly bookingPlayer: {
              readonly singular: string;
            } | null | undefined;
            readonly lessonPlayer: {
              readonly singular: string;
            } | null | undefined;
          };
        };
      };
    } | null | undefined;
  };
  readonly id: string;
  readonly nonPlayingHost?: boolean;
  readonly player: {
    readonly fullName: string;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"RoundInfoDisplay_Round" | "useGetLineItemsAndPriceForRound_Round">;
  readonly " $fragmentType": "Round_Round";
};
export type Round_Round$key = {
  readonly " $data"?: Round_Round$data;
  readonly " $fragmentSpreads": FragmentRefs<"Round_Round">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "singular",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Round_Round",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "player",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "fullName",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "booking",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "__typename",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "startSlot",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Agenda",
              "kind": "LinkedField",
              "name": "agenda",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Facility",
                  "kind": "LinkedField",
                  "name": "facility",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "FacilityCopyOverrides",
                      "kind": "LinkedField",
                      "name": "copyOverrides",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "NounOverride",
                          "kind": "LinkedField",
                          "name": "lessonPlayer",
                          "plural": false,
                          "selections": (v0/*: any*/),
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "NounOverride",
                          "kind": "LinkedField",
                          "name": "bookingPlayer",
                          "plural": false,
                          "selections": (v0/*: any*/),
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RoundInfoDisplay_Round"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useGetLineItemsAndPriceForRound_Round"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "nonPlayingHost",
          "storageKey": null
        }
      ],
      "type": "MemberRound",
      "abstractKey": null
    }
  ],
  "type": "Round",
  "abstractKey": "__isRound"
};
})();

(node as any).hash = "6989707ef9613776a5d5187e3b3763ec";

export default node;
